var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-skeleton-loader',{attrs:{"type":_vm.loaderType}})
}
var staticRenderFns = []

export { render, staticRenderFns }